import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import axios from 'axios';

import Search from '../Components/Main/Search';
import NavBar from '../Components/Main/NavBar';
import Footer from '../Components/Main/Footer';
import ProductCard from '../Components/Products/ProductCard';
import SidebarCategories from '../Components/Products/SideBarCategories';

import '../css/Products/Products.css';
import { SpinningCircles } from 'react-loading-icons';
import { AuthContext } from '../Context/AuthProvider';
import { useSearchParams } from 'react-router-dom';

const Products = () => {
  const [products, setProducts] = useState(null);
  const [detail, setDetail] = useState('');
  const [mobileCategoriesOpen, setMobileCategoriesOpen] = useState(true);

  const { category, subcategory } = useParams();
  const { user } = useContext(AuthContext);

  const location=useLocation();
  const [searchParams] = useSearchParams();

  const type = searchParams.get('type');
  

  useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL;

    const fetchProducts = async () => {
      try {
        const params = {
          ...(category && { category }),
          ...(subcategory && { subcategory }),
          ...(user?.id && { account_id: user.id }),
        };

          let apiRoute = '/wproducts'; // default
        if (type === 'machine') {
          apiRoute = '/machines';
        } else if (type === 'material') {
          apiRoute = '/wproducts';
        };

        const productsRes = await axios.get(`${API}${apiRoute}`, { params });
        setProducts(productsRes.data);


        if (category) {
          const categoryRes = await axios.get(`${API}/categorydetail`, {
            params: { category },
          });
          setDetail(categoryRes.data?.[0]?.category_description || '');
        } else {
          setDetail('');
        }

        
      } catch (error) {
        console.log(error);
      }
    };

    fetchProducts();
  }, [category, subcategory, user?.id]);

  return (
    <div className="product-site">
      <NavBar />

      <div className="products-page-layout">

        {/* DESKTOP SIDEBAR */}
        <div className="desktop-only">
          <Search />
          <SidebarCategories type={type} />
        </div>

        {/* MOBILE CATEGORY BUTTON */}
        <div className="mobile-only">
          <button
            className="mobile-category-button"
            onClick={() => setMobileCategoriesOpen(true)}
          >
            Kategóriák
          </button>
        </div>

        {/* MOBILE SIDEBAR DRAWER */}
        {mobileCategoriesOpen && (
          <div
            className="mobile-sidebar-overlay"
            onClick={() => setMobileCategoriesOpen(false)}
          >
            <div
              className="mobile-sidebar"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="close-sidebar"
                onClick={() => setMobileCategoriesOpen(false)}
              >
                ✕
              </button>

              <SidebarCategories type={type} onCategoryClick={() => setMobileCategoriesOpen(false)}/>
            </div>
          </div>
        )}

        {/* MAIN CONTENT */}
        <div className="products-content">
          <div className="products-category-title">
            {category && !subcategory && <h1>{category}</h1>}
            {subcategory && <h1>{subcategory}</h1>}
            {detail && <p>{detail}</p>}
          </div>

          <div className="products-container">
            {products ? (
              products.length > 0 ? (
                products.map((product, index) => (
                  <ProductCard key={index} product={product} type={type} />
                ))
              ) : (
                <p>Nincs találat ebben a kategóriában.</p>
              )
            ) : (
              <SpinningCircles />
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Products;